import clsx from 'clsx';
import React from 'react';
import styles from './Badge.module.scss';
export var BadgeTheme;
(function (BadgeTheme) {
    BadgeTheme["BLUE_DARK_100"] = "darkBlue100";
    BadgeTheme["BLUE_DARK_75"] = "darkBlue75";
    BadgeTheme["ACHROMATIC_CLOUD"] = "achromaticCloud";
    BadgeTheme["WHITE"] = "white";
    BadgeTheme["RED"] = "red";
    BadgeTheme["BORDERED_YELLOW"] = "borderedYellow";
    BadgeTheme["GREEN"] = "green";
    BadgeTheme["GREY"] = "grey";
})(BadgeTheme || (BadgeTheme = {}));
export const Badge = ({ text, iconAlignment = 'left', icon, theme = BadgeTheme.GREEN, className, }) => (<div className={clsx(styles.badge, iconAlignment === 'right' && styles.iconRight, styles[theme], className)}>
    {icon && (typeof icon === 'string' ? <img src={icon} alt='' role='presentation'/> : icon)}
    {text ? <span>{text}</span> : null}
  </div>);
